import { calculateStampDuty } from '@/pages/blueprint-lite/utils/stampDuty';

import type { AustralianState, StampDutyBracket } from '../types';

export { calculateStampDuty };

/**
 * Thrown by `computeLoan` when the live stamp-duty feed doesn't carry
 * brackets for the AU state the user has selected. The result page
 * catches this and renders a hard error, matching the policy used for
 * FX rates and HEM benchmarks.
 */
export class StampDutyBracketsMissingError extends Error {
  readonly state: AustralianState;
  constructor(state: AustralianState) {
    super(`Stamp-duty brackets unavailable for ${state}`);
    this.name = 'StampDutyBracketsMissingError';
    this.state = state;
  }
}

export function bracketsForState(
  brackets: Record<string, StampDutyBracket[]>,
  state: AustralianState,
): StampDutyBracket[] {
  const rows = brackets[state];
  if (!rows || rows.length === 0) {
    throw new StampDutyBracketsMissingError(state);
  }
  return rows;
}
